if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.bindNav();
      }

      bindNav() {
        const prev = this.querySelector('[data-modal-prev]');
        const next = this.querySelector('[data-modal-next]');
        if (prev) prev.addEventListener('click', (e) => { e.preventDefault(); this.step(-1); });
        if (next) next.addEventListener('click', (e) => { e.preventDefault(); this.step(1); });
        this.addEventListener('keydown', (e) => {
          if (!this.hasAttribute('open')) return;
          if (e.key === 'ArrowLeft') { e.preventDefault(); this.step(-1); }
          if (e.key === 'ArrowRight') { e.preventDefault(); this.step(1); }
        });
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      mediaItems() {
        return Array.from(this.querySelectorAll('.product-media-modal__content > [data-media-id]'));
      }

      activate(media) {
        if (!media) return;
        this.mediaItems().forEach((el) => el.classList.remove('active'));
        media.classList.add('active');
        media.scrollIntoView({ block: 'nearest' });

        const container = this.querySelector('[role="document"]');
        if (container && typeof media.width === 'number') {
          container.scrollLeft = (media.width - container.clientWidth) / 2;
        }

        const template = media.querySelector('template');
        const content = template ? template.content : null;
        if (media.nodeName === 'DEFERRED-MEDIA' && content && content.querySelector('.js-youtube')) {
          media.loadContent();
        }
      }

      step(direction) {
        const items = this.mediaItems();
        if (!items.length) return;
        const currentIndex = items.findIndex((el) => el.classList.contains('active'));
        const nextIndex = (currentIndex + direction + items.length) % items.length;
        this.activate(items[nextIndex]);
      }

      showActiveMedia() {
        const target = this.openedBy && this.openedBy.getAttribute('data-media-id');
        const items = this.mediaItems();
        const active = items.find((el) => el.getAttribute('data-media-id') === target) || items[0];
        this.activate(active);

        const nav = this.querySelectorAll('.product-media-modal__nav');
        nav.forEach((b) => { b.style.display = items.length > 1 ? '' : 'none'; });
      }
    }
  );
}
